import React, { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { TestimoniesManager } from "./TestimoniesManager";
import { ArticlesManager } from "./ArticlesManager";
import { MagazinesManager } from "./MagazinesManager";

interface KitDashboardProps {
  userRegion?: string;
  isGlobalAdmin: boolean;
}

export const KitDashboard: React.FC<KitDashboardProps> = ({
  userRegion,
  isGlobalAdmin,
}) => {
  const [activeTab, setActiveTab] = useState("testimonies");

  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <CardTitle>KIT Management Dashboard</CardTitle>
        </CardHeader>
        <CardContent>
          <Tabs value={activeTab} onValueChange={setActiveTab}>
            <TabsList className="grid w-full grid-cols-3">
              <TabsTrigger value="testimonies">Testimonies</TabsTrigger>
              <TabsTrigger value="articles">Articles</TabsTrigger>
              <TabsTrigger value="magazines">Magazines</TabsTrigger>
            </TabsList>
            
            <TabsContent value="testimonies" className="mt-6">
              <TestimoniesManager 
                userRegion={userRegion}
                isGlobalAdmin={isGlobalAdmin}
              />
            </TabsContent>
            
            <TabsContent value="articles" className="mt-6">
              <ArticlesManager 
                userRegion={userRegion}
                isGlobalAdmin={isGlobalAdmin}
              />
            </TabsContent>
            
            <TabsContent value="magazines" className="mt-6">
              <MagazinesManager 
                userRegion={userRegion}
                isGlobalAdmin={isGlobalAdmin}
              />
            </TabsContent>
          </Tabs>
        </CardContent>
      </Card>
    </div>
  );
};